import { useParams } from 'react-router-dom';
import { SpaceForm } from '~/components/space/SpaceForm';

export default function SiteSpaceEdit() {
  const { siteId, spaceId } = useParams();

  return (
    <div className='h-full overflow-hidden'>
      <SpaceForm title='Edit Space' reload={() => {}} />
    </div>
  );
}
